var Locales;
(function (Locales) {
    Locales["PT_BR"] = "pt-BR";
    Locales["EN_CA"] = "en-CA";
})(Locales || (Locales = {}));
export const DATETIME_INPUTS = ['date', 'time', 'datetime'];
export const DAY_MONTH_YEAR_FORMAT = 'DD/MM/YYYY';
export const DAY_MONTH_YEAR = {
    locale: Locales.PT_BR,
    options: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }
};
export const MONTH_YEAR_FORMAT = 'MM/YY';
export const MONTH_YEAR = {
    locale: Locales.PT_BR,
    options: {
        year: '2-digit',
        month: '2-digit'
    }
};
export const LONG_MONTH_YEAR_FORMAT = 'MON YYYY';
export const LONG_MONTH_YEAR = {
    locale: Locales.PT_BR,
    options: {
        month: 'long',
        year: 'numeric'
    }
};
export const DATETIME_FORMAT = 'DD/MM/YYYY HH:mm';
export const DATETIME = {
    locale: Locales.PT_BR,
    options: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    }
};
export const DAY_MONTH_FORMAT = 'DD/MM';
export const DAY_MONTH = {
    locale: Locales.PT_BR,
    options: {
        month: '2-digit',
        day: '2-digit'
    }
};
export const YEAR_MONTH_DAY_EN_CA_FORMAT = 'YYYY-MM-DD';
export const YEAR_MONTH_DAY_EN_CA = {
    locale: Locales.EN_CA,
    options: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }
};
export const TIME_REG_EXP = /([0-1][0-9]|(2)[0-3])(:)([0-5][0-9])(:)([0-5][0-9])/;
export const INVALID_DATE = 'Data inválida';
export const REGEX_DATETIME = {
    date: /^(((0[1-9]|[12][0-9]|30)[-/]?(0[13-9]|1[012])|31[-/]?(0[13578]|1[02])|(0[1-9]|1[0-9]|2[0-8])[-/]?02)[-/]?[0-9]{4}|29[-/]?02[-/]?([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00))$/i,
    datetime: /^(((0[1-9]|[12][0-9]|30)[-/]?(0[13-9]|1[012])|31[-/]?(0[13578]|1[02])|(0[1-9]|1[0-9]|2[0-8])[-/]?02)[-/]?[0-9]{4}|29[-/]?02[-/]?([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00)) ([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/i,
    time: /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/i
};
